import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import "./index.css"
import API from "../../api"
import Header from '../../components/custom/header'
import Transaction from './transaction'
import Tab from "../../components/holders/tab"
import Icon from '../../components/custom/icon'
import LineLoader from '../../components/info/lineloader'

function Home() {

  var [failed, setFailed] = useState()
  var [captured, setCaptured] = useState()
  var [syncing, setSyncing] = useState(false)
  var [showSync, setShowSync] = useState(false)
  var [showUpdate, setShowUpdate] = useState(false)
  var [syncDepth, setSyncDepth] = useState(0)

  var ref1 = useRef()
  var ref2 = useRef()
  var touchRef = useRef(null)

  const syncThresholdDepth = 0.05
  const syncMaxDepth = 0.3

  const sync = () => {
    setSyncing(true)
    new API().call("/get-payments").then(res => {
      setFailed(res.data[0])
      setCaptured(res.data[1])
    }).catch(e => {
      console.log(e)
    }).finally(() => {
      setSyncing(false)
      setShowSync(false)
      setSyncDepth(0)
    })
  }

  useEffect(() => {
    new API().call("/get-payments").then(res => {
      setFailed(res.data[0])
      setCaptured(res.data[1])
    })
  }, [])

  const handleTouchStart = (ref, e) => {
    if (ref.current.scrollTop == 0) {
      touchRef.current = e.touches[0].clientY
    }
  }

  const handleTouchMove = useCallback((ref, e) => {

    if (ref.current.scrollTop != 0) {
      return
    }

    if (showSync) {
      setSyncDepth(e.touches[0].clientY - touchRef.current > syncMaxDepth * window.innerHeight ? syncMaxDepth * window.innerHeight : e.touches[0].clientY - touchRef.current)
    } else if ((e.touches[0].clientY - touchRef.current) / window.innerHeight >= syncThresholdDepth) {
      setShowSync(true)
    }
  }, [showSync])

  var depthRatio = syncDepth / (syncMaxDepth * window.innerHeight)

  var failedTrans = useMemo(() => {
    return failed && failed.map(c => {
      return <Transaction transaction={c} failed setFailed={setFailed} setCaptured={setCaptured} key={c.id} />
    })
  }, [failed])

  var capturedTrans = useMemo(() => {
    return captured && captured.map(c => {
      return <Transaction transaction={c} setFailed={setFailed} setCaptured={setCaptured} key={c.id} />
    })
  }, [captured])

  const tabs = captured !== undefined ? [
    {
      header: "Failed",
      comp: <>
        {showSync && <div
          className={`home-sync ${syncing ? "ing" : ""}`}
          style={
            {
              top: `${syncDepth}px`,
              opacity: depthRatio,
              transform: `translate(-50%, -50%) rotate(${depthRatio * 360}deg)`
            }
          }><Icon name="sync" color="#fff"></Icon></div>}
        <div className='home-tab-main' ref={ref1}
          onTouchStart={e => { handleTouchStart(ref1, e) }}
          onTouchMove={e => { handleTouchMove(ref1, e) }}
          onTouchEnd={sync}
        >{failedTrans}</div>
      </>
    },
    {
      header: "Success",
      comp: <>
        {showSync && <div
          className={`home-sync ${syncing ? "ing" : ""}`}
          style={
            {
              top: `${syncDepth}px`,
              opacity: depthRatio,
              transform: `translate(-50%, -50%) rotate(${depthRatio * 360}deg)`
            }
          }><Icon name="sync" color="#fff"></Icon></div>}
        <div className='home-tab-main' ref={ref2}
          onTouchStart={e => { handleTouchStart(ref2, e) }}
          onTouchMove={e => { handleTouchMove(ref2, e) }}
          onTouchEnd={sync}
        >{capturedTrans}</div>
      </>
    }
  ] : null


  const contextMenuConfig = [
    {
      name: 'Force Sync',
      onClick: () => {
        setShowUpdate(true)
        new API().call("/update-payments").then(res => {
          setFailed(res.data[0])
          setCaptured(res.data[1])
        }).finally(() => {
          setShowUpdate(false)
        })
      }
    }
  ]

  return (
    <div>
      <Header title={'Razorpay Utils'} sync={sync} contextMenuConfig={contextMenuConfig} />
      {showUpdate && <LineLoader />}
      {captured !== undefined ? <Tab tabs={tabs} /> : null}
    </div >
  )
}


export default Home
